/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ClaimInputs */

const en_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim`)
};

const ar_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استلام`)
};

const de_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abholen`)
};

const es_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamar`)
};

const fr_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenir`)
};

const it_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscatta`)
};

const ja_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受け取る`)
};

const ko_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`받기`)
};

const pt_br_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resgatar`)
};

const ru_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получить`)
};

const th_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แลกรับ`)
};

const tr_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al`)
};

const zh_cn_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`领取`)
};

const zh_tw_claim = /** @type {(inputs: ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`領取`)
};

/**
* | output |
* | --- |
* | "Claim" |
*
* @param {ClaimInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const claim = /** @type {((inputs?: ClaimInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ClaimInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claim(inputs)
	if (locale === "ar") return ar_claim(inputs)
	if (locale === "de") return de_claim(inputs)
	if (locale === "es") return es_claim(inputs)
	if (locale === "fr") return fr_claim(inputs)
	if (locale === "it") return it_claim(inputs)
	if (locale === "ja") return ja_claim(inputs)
	if (locale === "ko") return ko_claim(inputs)
	if (locale === "pt_br") return pt_br_claim(inputs)
	if (locale === "ru") return ru_claim(inputs)
	if (locale === "th") return th_claim(inputs)
	if (locale === "tr") return tr_claim(inputs)
	if (locale === "zh_cn") return zh_cn_claim(inputs)
	return zh_tw_claim(inputs)
});